import { PEOPLE_DIRECTORY_PATH, PROFILE_PAGE } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const profileRoute = createGlobalRoute({
  exact: true,
  name: PROFILE_PAGE,
  path: `${PEOPLE_DIRECTORY_PATH}/:id/(work)?`,
  subproduct: 'townsquare-people-team-directory',
  layout: 'expanded',
});

// This route is used for matching the nav item in the left sidebar in the Teams app
export const profileRouteTeamsMatch = createGlobalRoute({
  exact: true,
  name: PROFILE_PAGE,
  // Use a regex to exclude 'global-search', 'kudos', 'teams' from matching as :id as it belongs to other routes
  path: `${PEOPLE_DIRECTORY_PATH}/:id((?!global-search$|search$|kudos$|team$)[^/]+)/(work)?`,
  subproduct: 'townsquare-people-team-directory',
  layout: 'expanded',
});
